import React, { Component } from 'react'
import {
  VictoryAxis,
  VictoryChart,
  VictoryLegend,
  VictoryLine,
  VictoryTheme,
} from 'victory'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"

class TrackerSampleChart extends Component {
  constructor(props) {
    super(props)

    this.state = {
      checked: false,
      graph_config_status: 1,
      graph_type: 1,
      graph_data_show: 1,
      tracker_timeback: 1,
      tracker_day: [],
      tracker_week: [],
    }
  }

  componentDidMount() {
    this.getDataList()
  }

  getDataList = () => {
    var get_tracker_day = []
    var get_tracker_week = []
    // tracker day //
    this.setState({
      tracker_day: this.getSampleData1(),
      //tracker_week: get_tracker_week,
    })
  }

  normalizeValue = (value, originalMin, originalMax) => {
    if ( value === null || value === undefined || value === '' || Number(value) < originalMin ) {
      return null
    }
    const normalized = 1 + ((Number(value) - originalMin) * 4) / (originalMax - originalMin)
    return Math.round(normalized * 100) / 100
  }

  parseDate = value => {
    if (!value) {
      return null
    }

    // For API dates such as 2026-08-09T00:00:00
    if (value.indexOf('-') !== -1) {
      const datePart = value.split('T')[0]
      const parts = datePart.split('-')

      return new Date(
        Number(parts[0]),
        Number(parts[1]) - 1,
        Number(parts[2])
      )
    }

    // For sample dates such as 09/08/26
    const parts = value.split('/')

    return new Date(
      2000 + Number(parts[2]),
      Number(parts[1]) - 1,
      Number(parts[0])
    )
  }

  formatDate = value => {
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) { return '' }
    return `${date.getMonth() + 1}/${date.getDate()}`
  }

  getChartData = () => {
    return this.getTrackerSelection().data
  }

  getRecentData = (data, latestDate) => {
    if (!latestDate) { return [] }

    const cutoff = new Date(latestDate)
    cutoff.setMonth(cutoff.getMonth() - 1)

    return data
      .filter(item => {
        const date = this.parseDate(item.date)
        return date && date >= cutoff && date <= latestDate
      })
      .sort((a, b) => this.parseDate(a.date) - this.parseDate(b.date))
  }

  getTrackerSelection = () => {
    const daily = [...this.state.tracker_day].sort(
      (a, b) => this.parseDate(a.date) - this.parseDate(b.date)
    )

    return {
      type: 'Daily',
      data: daily,
    }
  }

  getLineData = (
    key,
    minimum,
    maximum,
    reverse = false
  ) => {
    return this.getChartData()
      .map(item => {
        const originalValue = Number(item[key])
        const date = this.parseDate(item.date)

        if (
          Number.isNaN(originalValue) ||
          !date ||
          Number.isNaN(date.getTime())
        ) {
          return null
        }

        const convertedValue =
          maximum === 5 && minimum === 1
            ? originalValue
            : this.normalizeValue(
                originalValue,
                minimum,
                maximum
              )

        return {
          x: date,
          y: convertedValue,
          date: item.date,
        }
      })
      .filter(Boolean)
  }

  getDateDomain = () => {
    const dates = this.getChartData()
      .map(row => this.parseDate(row.date))
      .filter(date => {
        return date && !Number.isNaN(date.getTime())
      })

    const today = new Date()
    today.setHours(0, 0, 0, 0)

    if (dates.length === 0) {
      const oneMonthAgo = new Date(today)
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1)

      return [oneMonthAgo, today]
    }

    const firstDate = new Date(
      Math.min(...dates.map(date => date.getTime()))
    )

    return [firstDate, today]
  }

  renderLine = (
    key,
    color,
    minimum,
    maximum,
    reverse = false
  ) => {
    const data = this.getLineData(
      key,
      minimum,
      maximum,
      reverse
    )

    return (
      <VictoryLine
        key={key}
        data={data}
        style={{
          data: {
            stroke: color,
            strokeWidth: key === 'anxiety' ? 2 : 1.5,
            strokeDasharray: key === 'anxiety' ? '1,4' : 'none',
            strokeLinecap: 'round',
          },
        }}
      />
    )
  }

  getXAxisTicks = () => {
    const dates = this.getChartData()
      .map(item => this.parseDate(item.date))
      .filter(
        date =>
          date &&
          !Number.isNaN(date.getTime())
      )
      .sort((a, b) => a - b)

    if (dates.length === 0) {
      return []
    }

    const firstDate = new Date(dates[0])
    const lastDate = new Date(
      dates[dates.length - 1]
    )

    const ticks = []
    const currentDate = new Date(firstDate)

    while (currentDate <= lastDate) {
      ticks.push(new Date(currentDate))
      currentDate.setDate(
        currentDate.getDate() + 7
      )
    }

    return ticks
  }

  formatXAxisDate = value => {
    const date = new Date(value)

    if (Number.isNaN(date.getTime())) {
      return ''
    }

    return `${
      date.getMonth() + 1
    }/${date.getDate()}`
  }

  getSampleData1 = () => {
    const sampleData = [
      { date: '24/06/26', mood_manic: 1, mood_depressed: 1, sleep: 4, medication: 5, exercise: 1, anxiety: 1 },
      { date: '06/07/26', mood_manic: 1, mood_depressed: 1, sleep: 4, medication: 5, exercise: 4.5, anxiety: 1 },
      { date: '09/07/26', mood_manic: 1, mood_depressed: 1, sleep: 4, medication: 5, exercise: 2.5, anxiety: 1 },
      { date: '12/07/26', mood_manic: 1, mood_depressed: 1, sleep: 4, medication: 5, exercise: 2, anxiety: 1 },
      { date: '14/07/26', mood_manic: 1, mood_depressed: 1, sleep: 4, medication: 5, exercise: 1, anxiety: 1 },
      { date: '16/07/26', mood_manic: 1, mood_depressed: 1, sleep: 4, medication: 5, exercise: 1, anxiety: 1 },
      { date: '20/07/26', mood_manic: 1, mood_depressed: 1.5, sleep: 2.5, medication: 5, exercise: 1, anxiety: 1.5 },
      { date: '24/07/26', mood_manic: 1, mood_depressed: 1, sleep: 4, medication: 5, exercise: 1, anxiety: 1 },
      { date: '29/07/26', mood_manic: 1, mood_depressed: 1, sleep: 4, medication: 5, exercise: 1, anxiety: 1 },
      { date: '02/08/26', mood_manic: 1, mood_depressed: 1.5, sleep: 2, medication: 5, exercise: 1, anxiety: 1 },
      { date: '08/08/26', mood_manic: 1, mood_depressed: 1.5, sleep: 3, medication: 3, exercise: 1, anxiety: 1 },
      { date: '09/08/26', mood_manic: 1, mood_depressed: 1.5, sleep: 2, medication: 5, exercise: 1, anxiety: 1 },
      { date: '11/08/26', mood_manic: 1, mood_depressed: 1, sleep: 4, medication: 5, exercise: 1, anxiety: 1 },
      { date: '17/08/26', mood_manic: 1, mood_depressed: 1.5, sleep: 4, medication: 5, exercise: 4, anxiety: 1 },
      { date: '23/08/26', mood_manic: 1, mood_depressed: 1, sleep: 4, medication: 5, exercise: 1, anxiety: 1 },
    ];

    return sampleData
  }
  renderTrackerChart = (title, lines) => {
    const chartData = this.getChartData()
    const xAxisTicks = this.getXAxisTicks()
    const chartDates = chartData
      .map(item => this.parseDate(item.date))
      .filter(
        date =>
          date &&
          !Number.isNaN(date.getTime())
      )
      .sort((a, b) => a - b)

    const xDomain = [
      chartDates[0],
      chartDates[chartDates.length - 1],
    ]

    return (
      <div style={{ marginBottom: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 1 }}>
          {title}
        </div>

        <VictoryChart
          theme={VictoryTheme.material}
          height={130}
          scale={{ x: 'time' }}
          padding={{
            top: 32,
            bottom: 38,
            left: 38,
            right: 20,
          }}
          domain={{
            x: xDomain,
            y: [0.7, 5.3],
          }}
        >
          <VictoryLegend
            x={55}
            y={5}
            orientation="horizontal"
            gutter={18}
            style={{ labels: { fontSize: 7 } }}
            data={lines.map(line => ({
              name: line.label,
              symbol: { fill: line.color },
            }))}
          />

          <VictoryAxis
            tickValues={xAxisTicks}
            tickFormat={date =>
              this.formatXAxisDate(date)
            }
            style={{
              axis: { stroke: '#cccccc' },
              grid: {
                stroke: '#eeeeee',
                strokeDasharray: '4,4',
              },
              ticks: {
                stroke: '#cccccc',
                size: 2,
              },
              tickLabels: {
                fontSize: 6,
                padding: 3,
                angle: -45,
                textAnchor: 'end',
              },
            }}
          />

          <VictoryAxis
            dependentAxis
            tickValues={[1, 2, 3, 4, 5]}
            style={{
              axis: { stroke: '#cccccc' },
              grid: {
                stroke: '#eeeeee',
                strokeDasharray: '4,4',
              },
              ticks: {
                stroke: '#cccccc',
                size: 2,
              },
              tickLabels: {
                fontSize: 6,
                padding: 4,
              },
            }}
          />

          {lines.map(line => this.renderLine(
            line.key,
            line.color,
            line.minimum,
            line.maximum
          ))}
        </VictoryChart>
      </div>
    )
  }

  render() {
    const selection = this.getTrackerSelection()
    const chartData = selection.data

    if (chartData.length === 0) {
      return (
        <div className="small-12 columns">
          Not enough tracker information to display a trend.
        </div>
      )
    }

    const firstDate = this.formatDate(this.parseDate(chartData[0].date))
    const lastDate = this.formatDate(
      this.parseDate(chartData[chartData.length - 1].date)
    )

    const moodLines = [
      { key: 'mood_manic', label: 'Mania', color: '#00acc1', minimum: 1, maximum: 5 },
      { key: 'mood_depressed', label: 'Depression', color: '#7e57c2', minimum: 1, maximum: 5 },
      { key: 'anxiety', label: 'Anxiety', color: '#d81b60', minimum: 1, maximum: 5 },
    ]

    const routineLines = [
      { key: 'sleep', label: 'Sleep', color: '#1e88e5', minimum: 1, maximum: 7 },
      { key: 'exercise', label: 'Exercise', color: '#fb8c00', minimum: 1, maximum: 8 },
      { key: 'medication', label: 'Medication', color: '#43a047', minimum: 1, maximum: 5 },
    ]

    return (
      <div className="small-12 columns">
        <div className="title6">Daily Trackers</div>

        {this.renderTrackerChart('Mood and Anxiety', moodLines)}
        {/*this.renderTrackerChart(
          'Sleep, Exercise, and Medication',
          routineLines
        )*/}
      </div>
    )
  }

}

const mapStateToProps = (state) => {
  //console.log('Dashboard STATE: ', state)
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    //console.log('Dashboard mapDispatchToProps')
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(TrackerSampleChart)
